
(function () {
    "use strict";

    try {
        if (window.__salepifyGicClaimedGiftDisplayPatched) return;
        window.__salepifyGicClaimedGiftDisplayPatched = true;

        var TAG = "[Custom][GIC Claimed Gift Display]";
        var MAX_PATCH_ATTEMPTS = 40;
        var RETRY_DELAY_MS = 250;

        // Cache cart items: map key/id -> { id, key, title, image }
        var cartItemsMap = new Map();

        function normalizeImageUrl(url) {
            try {
                if (!url || typeof url !== "string") return "";
                if (url.indexOf("//") === 0) return "https:" + url;
                return url;
            } catch (e) {
                return url || "";
            }
        }

        function recordCartItems(cart) {
            try {
                if (!cart || !Array.isArray(cart.items)) return;
                cart.items.forEach(function (item) {
                    try {
                        if (!item) return;
                        var id = String(item.id || item.variant_id || "");
                        var key = String(item.key || "");
                        var image = normalizeImageUrl(item.image || (item.featured_image && (item.featured_image.url || item.featured_image)));
                        var title = item.title || item.product_title || "";
                        var info = { id: id, key: key, title: title, image: image };

                        if (key) cartItemsMap.set(key, info);
                        if (id) cartItemsMap.set(id, info);
                    } catch (itemErr) {}
                });
            } catch (err) {}
        }

        // Intercept fetch & XMLHttpRequest an toàn để cập nhật cartItemsMap
        function interceptCartRequests(onCartUpdated) {
            try {
                // 1. Fetch interceptor
                if (typeof window.fetch === "function") {
                    var originalFetch = window.fetch;
                    window.fetch = function () {
                        var args = arguments;
                        var isCartReq = false;
                        try {
                            var url = args[0];
                            if (typeof url === "string") {
                                isCartReq = url.indexOf("/cart") !== -1;
                            } else if (url && typeof url.url === "string") {
                                isCartReq = url.url.indexOf("/cart") !== -1;
                            }
                        } catch (urlErr) {
                            isCartReq = false;
                        }

                        var fetchPromise;
                        try {
                            fetchPromise = originalFetch.apply(this, args);
                        } catch (applyErr) {
                            return Promise.reject(applyErr);
                        }

                        if (!isCartReq) return fetchPromise;

                        return fetchPromise.then(function (response) {
                            try {
                                if (response && typeof response.clone === "function") {
                                    response.clone().json().then(function (data) {
                                        try {
                                            recordCartItems(data);
                                            if (typeof onCartUpdated === "function") onCartUpdated();
                                        } catch (cbErr) {}
                                    }).catch(function () {});
                                }
                            } catch (cloneErr) {}
                            return response;
                        });
                    };
                }

                // 2. XMLHttpRequest interceptor
                if (typeof window.XMLHttpRequest === "function") {
                    var originalOpen = XMLHttpRequest.prototype.open;
                    var originalSend = XMLHttpRequest.prototype.send;

                    XMLHttpRequest.prototype.open = function (method, url) {
                        try {
                            this.__salepifyUrl = url;
                        } catch (e) {}
                        return originalOpen.apply(this, arguments);
                    };

                    XMLHttpRequest.prototype.send = function () {
                        var xhr = this;
                        try {
                            var url = xhr.__salepifyUrl;
                            if (typeof url === "string" && url.indexOf("/cart") !== -1) {
                                xhr.addEventListener("load", function () {
                                    try {
                                        var data = JSON.parse(xhr.responseText);
                                        recordCartItems(data);
                                        if (typeof onCartUpdated === "function") onCartUpdated();
                                    } catch (e) {}
                                });
                            }
                        } catch (e) {}
                        return originalSend.apply(this, arguments);
                    };
                }
            } catch (interErr) {
                console.error(TAG, "Lỗi khi thiết lập intercept:", interErr);
            }
        }

        // Gọi /cart.js lúc khởi tạo để cache sẵn line items
        function fetchInitialCart(onCartUpdated) {
            try {
                if (typeof fetch === "function") {
                    fetch("/cart.js")
                        .then(function (res) { return res.json(); })
                        .then(function (cart) {
                            try {
                                recordCartItems(cart);
                                if (typeof onCartUpdated === "function") onCartUpdated();
                            } catch (e) {}
                        })
                        .catch(function () {});
                }
            } catch (e) {}
        }

        // Lấy thông tin { title, image } của món quà được claim
        function resolveGiftDetails(widget, offer, addedGift) {
            try {
                if (!addedGift) return null;
                var giftId = String(addedGift.id || "");
                var giftKey = String(addedGift.key || "");
                var cleanId = giftId.replace(/\D/g, "");

                // 1. Kiểm tra trong cartItemsMap (từ Shopify cart line items)
                if (giftKey && cartItemsMap.has(giftKey)) {
                    var itemByKey = cartItemsMap.get(giftKey);
                    if (itemByKey && (itemByKey.image || itemByKey.title)) {
                        return itemByKey;
                    }
                }
                if (giftId && cartItemsMap.has(giftId)) {
                    var itemById = cartItemsMap.get(giftId);
                    if (itemById && (itemById.image || itemById.title)) {
                        return itemById;
                    }
                }

                // 2. Kiểm tra qua module adapter (getResourceData)
                try {
                    if (widget && typeof widget.getModuleAdapter === "function") {
                        var adapter = widget.getModuleAdapter(offer.module);
                        if (adapter && typeof adapter.getResourceData === "function") {
                            var resource = adapter.getResourceData(giftId) || (cleanId ? adapter.getResourceData(cleanId) : null);
                            if (resource && (resource.image || resource.title)) {
                                return {
                                    id: giftId,
                                    title: resource.title || "",
                                    image: normalizeImageUrl(resource.image)
                                };
                            }
                        }
                    }
                } catch (err) {}

                // 3. Kiểm tra trong window.tlFreeGiftOffer.shopifyIdMapData
                try {
                    if (window.tlFreeGiftOffer && window.tlFreeGiftOffer.shopifyIdMapData) {
                        var shopifyData = window.tlFreeGiftOffer.shopifyIdMapData.get(cleanId) ||
                                          window.tlFreeGiftOffer.shopifyIdMapData.get(giftId);
                        if (shopifyData && (shopifyData.image || shopifyData.title)) {
                            return {
                                id: giftId,
                                title: shopifyData.title || "",
                                image: normalizeImageUrl(shopifyData.image)
                            };
                        }
                    }
                } catch (err) {}

                return null;
            } catch (err) {
                console.error(TAG, "Lỗi resolveGiftDetails:", err);
                return null;
            }
        }

        // Cập nhật DOM của 1 card cụ thể
        function updateCardUI(card, claimedGift) {
            try {
                if (!card) return;
                var imgEl = card.querySelector(".salepify-gic__offer-image");
                var nameEl = card.querySelector(".salepify-gic__offer-name");
                var topEl = card.querySelector(".salepify-gic__offer-top");
                var badgeEl = card.querySelector(".salepify-gic__offer-badge");
                var optionsEl = card.querySelector(".salepify-gic__offer-options");

                // Lưu trạng thái ban đầu để có thể revert khi khách bỏ chọn quà
                if (!card.dataset.gicInitialSaved) {
                    card.dataset.gicInitialSaved = "1";
                    card.dataset.gicInitialImg = imgEl ? imgEl.src : "";
                    card.dataset.gicInitialTitle = nameEl ? nameEl.textContent.trim() : "";
                    card.dataset.gicInitialTooltip = topEl ? (topEl.getAttribute("data-tooltip") || "") : "";
                }

                if (claimedGift && (claimedGift.image || claimedGift.title)) {
                    // Đã add gift: hiển thị ảnh & tên của quà đã add
                    if (imgEl && claimedGift.image) {
                        imgEl.src = claimedGift.image;
                        if (claimedGift.title) imgEl.alt = claimedGift.title;
                    }
                    if (nameEl && claimedGift.title) {
                        nameEl.textContent = claimedGift.title;
                    }
                    if (topEl && claimedGift.title) {
                        topEl.setAttribute("data-tooltip", claimedGift.title);
                    }

                    // Ẩn badge +N và options subtitle
                    if (badgeEl) badgeEl.style.display = "none";
                    if (optionsEl) optionsEl.style.display = "none";
                } else {
                    // Chưa add gift / đã remove gift: revert về ban đầu
                    if (card.dataset.gicInitialSaved) {
                        if (imgEl && card.dataset.gicInitialImg) {
                            imgEl.src = card.dataset.gicInitialImg;
                            if (card.dataset.gicInitialTitle) imgEl.alt = card.dataset.gicInitialTitle;
                        }
                        if (nameEl && card.dataset.gicInitialTitle) {
                            nameEl.textContent = card.dataset.gicInitialTitle;
                        }
                        if (topEl && card.dataset.gicInitialTooltip) {
                            topEl.setAttribute("data-tooltip", card.dataset.gicInitialTooltip);
                        }
                    }

                    // Hiện lại badge +N và options subtitle
                    if (badgeEl) badgeEl.style.display = "";
                    if (optionsEl) optionsEl.style.display = "";
                }
            } catch (err) {
                console.error(TAG, "Lỗi updateCardUI:", err);
            }
        }

        // Đồng bộ hiển thị cho tất cả card của 1 offer
        function syncOfferCardDisplay(widget, offer) {
            try {
                if (!widget || !offer || !widget.utils) return;
                var ruleKey = widget.utils.getRuleKey(offer.id, offer.module);
                var cards = document.querySelectorAll('.salepify-gic__offer-card[data-rule-key="' + ruleKey + '"]');
                if (!cards.length) return;

                var addedGifts = [];
                try {
                    if (typeof widget.getAddedGifts === "function") {
                        addedGifts = widget.getAddedGifts(offer.id, offer.module) || [];
                    }
                } catch (e) {
                    addedGifts = [];
                }

                var claimedGift = null;
                if (addedGifts && addedGifts.length > 0) {
                    // Lấy món quà được claim đầu tiên trong giỏ hàng
                    var firstAdded = addedGifts[0];
                    claimedGift = resolveGiftDetails(widget, offer, firstAdded);

                    // Nếu chưa có chi tiết trong cache, fetch lại /cart.js để cập nhật
                    if (!claimedGift) {
                        fetchInitialCart(function () {
                            try {
                                syncOfferCardDisplay(widget, offer);
                            } catch (e) {}
                        });
                    }
                }

                cards.forEach(function (card) {
                    updateCardUI(card, claimedGift);
                });
            } catch (err) {
                console.error(TAG, "Lỗi syncOfferCardDisplay:", err);
            }
        }

        // Đồng bộ toàn bộ offers trong widget
        function syncAllOffers(widget) {
            try {
                if (!widget || !Array.isArray(widget.offers)) return;
                widget.offers.forEach(function (offer) {
                    syncOfferCardDisplay(widget, offer);
                });
            } catch (err) {
                console.error(TAG, "Lỗi syncAllOffers:", err);
            }
        }

        // Patch vào window.tlGiftInCartWidget
        function patchWidget(widget) {
            try {
                if (!widget || widget.__salepifyClaimedGiftPatched) return false;
                widget.__salepifyClaimedGiftPatched = true;

                // Hook vào updateOfferCardUI
                if (typeof widget.updateOfferCardUI === "function") {
                    var origUpdateOfferCardUI = widget.updateOfferCardUI.bind(widget);
                    widget.updateOfferCardUI = function (offer) {
                        try {
                            origUpdateOfferCardUI(offer);
                        } catch (coreErr) {
                            console.error(TAG, "Lỗi trong core updateOfferCardUI:", coreErr);
                        }
                        try {
                            syncOfferCardDisplay(widget, offer);
                        } catch (err) {
                            console.error(TAG, "Lỗi khi đồng bộ UI card:", err);
                        }
                    };
                }

                // Hook vào updateAllOfferCardsUI
                if (typeof widget.updateAllOfferCardsUI === "function") {
                    var origUpdateAllOfferCardsUI = widget.updateAllOfferCardsUI.bind(widget);
                    widget.updateAllOfferCardsUI = async function () {
                        var res;
                        try {
                            res = await origUpdateAllOfferCardsUI();
                        } catch (coreErr) {
                            console.error(TAG, "Lỗi trong core updateAllOfferCardsUI:", coreErr);
                        }
                        try {
                            syncAllOffers(widget);
                        } catch (err) {
                            console.error(TAG, "Lỗi khi đồng bộ tất cả UI card:", err);
                        }
                        return res;
                    };
                }

                // Hook vào renderGICWidget
                if (typeof widget.renderGICWidget === "function") {
                    var origRenderGICWidget = widget.renderGICWidget.bind(widget);
                    widget.renderGICWidget = async function () {
                        var res;
                        try {
                            res = await origRenderGICWidget();
                        } catch (coreErr) {
                            console.error(TAG, "Lỗi trong core renderGICWidget:", coreErr);
                        }
                        try {
                            syncAllOffers(widget);
                        } catch (err) {
                            console.error(TAG, "Lỗi sau khi render widget:", err);
                        }
                        return res;
                    };
                }

                // Đồng bộ ngay lập tức cho các card hiện có trong DOM
                syncAllOffers(widget);
                console.log(TAG, "Patched window.tlGiftInCartWidget successfully");
                return true;
            } catch (patchErr) {
                console.error(TAG, "Lỗi patchWidget:", patchErr);
                return false;
            }
        }

        // Khởi động
        interceptCartRequests(function () {
            try {
                if (window.tlGiftInCartWidget) {
                    syncAllOffers(window.tlGiftInCartWidget);
                }
            } catch (e) {}
        });

        fetchInitialCart(function () {
            try {
                if (window.tlGiftInCartWidget) {
                    syncAllOffers(window.tlGiftInCartWidget);
                }
            } catch (e) {}
        });

        var attempts = 0;
        function tryPatch() {
            try {
                if (window.tlGiftInCartWidget && typeof window.tlGiftInCartWidget.updateOfferCardUI === "function") {
                    patchWidget(window.tlGiftInCartWidget);
                    return;
                }
                attempts++;
                if (attempts < MAX_PATCH_ATTEMPTS) {
                    setTimeout(tryPatch, RETRY_DELAY_MS);
                }
            } catch (err) {
                console.error(TAG, "Lỗi tryPatch:", err);
            }
        }

        tryPatch();
    } catch (globalErr) {
        console.error("[Custom][GIC Claimed Gift Display] Global init error:", globalErr);
    }
})();
